import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Users, Phone, Mail, Percent, Coins } from "lucide-react";
import { OrderDetailData } from "@/types/orders";
import { formatCurrency } from "@/config/order-constants";

interface OrderPartnerCardProps {
  partner: OrderDetailData["partners"];
  order: OrderDetailData;
}

export function OrderPartnerCard({ partner, order }: OrderPartnerCardProps) {
  if (!partner) {
    return null;
  }

  const getCommissionDisplay = () => {
    if (!order.commission_type || !order.commission_value) return null;

    if (order.commission_type === "percentage") {
      return `${order.commission_value}%`;
    }
    return formatCurrency(order.commission_value);
  };

  const commissionDisplay = getCommissionDisplay();

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Users className="h-5 w-5" />
          Yhteistyökumppani
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <p className="font-medium">{partner.name}</p>

        {partner.phone && (
          <div className="flex items-center gap-3">
            <Phone className="h-4 w-4 text-muted-foreground" />
            <a
              href={`tel:${partner.phone}`}
              className="text-sm hover:underline"
            >
              {partner.phone}
            </a>
          </div>
        )}

        {partner.email && (
          <div className="flex items-center gap-3">
            <Mail className="h-4 w-4 text-muted-foreground" />
            <a
              href={`mailto:${partner.email}`}
              className="text-sm hover:underline"
            >
              {partner.email}
            </a>
          </div>
        )}

        {commissionDisplay && (
          <div className="pt-2 border-t">
            <div className="flex items-center gap-3">
              {order.commission_type === "percentage" ? (
                <Percent className="h-4 w-4 text-muted-foreground" />
              ) : (
                <Coins className="h-4 w-4 text-muted-foreground" />
              )}
              <div className="text-sm">
                <span className="text-muted-foreground">Provisio: </span>
                <span className="font-medium">{commissionDisplay}</span>
                {order.commission_amount && (
                  <span className="text-muted-foreground">
                    {" "}
                    ({formatCurrency(order.commission_amount)})
                  </span>
                )}
              </div>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
